import styled from '@emotion/styled';

interface PageContainerProps {
  backgroundColor: string;
  backgroundImage?: string;
  backgroundImageOpacity: number;
  backgroundPosition: string;
}

export const PageContainer = styled.div<PageContainerProps>(
  {
    transition: 'opacity 0.3s ease',
    position: 'relative',
  },
  props => ({
    background: props.backgroundColor,
    '&::before': {
      content: '""',
      position: 'absolute',
      backgroundImage: `url(${props.backgroundImage})`,
      opacity: props.backgroundImageOpacity,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: props.backgroundPosition,
      backgroundSize: 'cover',
      inset: 0,
      zIndex: 0,
    },
  })
);
